
import Dash from "../../../assets/outline/Dash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DashIcon({ className, dataTestid = "DashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Dash data-testid={dataTestid} className={classes} {...rest} />
  );
}
